
export const GLOBALS: {
    language: string
} = {
    language : 'en'
}